import { Container, Sprite, Texture } from 'pixi.js';
import gsap from 'gsap';
import type { Difficulty } from '../config/difficulty';
import { AudioBus, playUIClick } from '../engine/audio';

export interface DifficultyCardOptions {
  x: number;
  y: number;
  textureKey: string;
  difficulty: Difficulty;
  onClick: (d: Difficulty) => void;
  audio?: AudioBus;
}

const IDLE_VISUAL_SCALE = 1.05;
const HOVER_VISUAL_SCALE = 1.12;
const PRESS_VISUAL_SCALE = 1.0;

export class DifficultyCard extends Container {
  private visual: Container;

  constructor(opts: DifficultyCardOptions) {
    super();
    this.position.set(opts.x, opts.y);

    this.visual = new Container();
    this.visual.scale.set(IDLE_VISUAL_SCALE);
    this.addChild(this.visual);

    const card = new Sprite(Texture.from(opts.textureKey));
    card.anchor.set(0.5);
    this.visual.addChild(card);

    const w = card.width * IDLE_VISUAL_SCALE;
    const h = card.height * IDLE_VISUAL_SCALE;
    this.eventMode = 'static';
    this.cursor = 'pointer';
    this.hitArea = {
      contains: (x: number, y: number): boolean =>
        x >= -w / 2 && x <= w / 2 && y >= -h / 2 && y <= h / 2,
    };

    const baseY = opts.y;
    this.on('pointerover', () => {
      gsap.to(this, { y: baseY - 12, duration: 0.18, ease: 'sine.out' });
      gsap.to(this.visual.scale, { x: HOVER_VISUAL_SCALE, y: HOVER_VISUAL_SCALE, duration: 0.18, ease: 'sine.out' });
    });
    this.on('pointerout', () => {
      gsap.to(this, { y: baseY, duration: 0.18, ease: 'sine.out' });
      gsap.to(this.visual.scale, { x: IDLE_VISUAL_SCALE, y: IDLE_VISUAL_SCALE, duration: 0.18, ease: 'sine.out' });
    });
    this.on('pointerdown', () => {
      gsap.fromTo(
        this.visual.scale,
        { x: HOVER_VISUAL_SCALE, y: HOVER_VISUAL_SCALE },
        { x: PRESS_VISUAL_SCALE, y: PRESS_VISUAL_SCALE, duration: 0.08, yoyo: true, repeat: 1 }
      );
      playUIClick(opts.audio ?? null);
      opts.onClick(opts.difficulty);
    });
  }
}
